import { SearchX } from 'lucide-react';

interface HelpEmptyStateProps {
  searchTerm: string;
  onContactSupport: () => void;
}

export function HelpEmptyState({ searchTerm, onContactSupport }: HelpEmptyStateProps) {
  const trimmed = searchTerm.trim();
  return (
    <div className="flex flex-1 flex-col items-center justify-center px-8 py-5 text-center">
      <div className="mb-3.5 flex h-[52px] w-[52px] items-center justify-center rounded-full bg-surface-2 text-subtle">
        <SearchX className="h-6 w-6" />
      </div>
      <h4 className="mb-1 text-h6 text-primary">No encontramos ese tema</h4>
      <p className="mb-3.5 text-caption text-muted">
        {trimmed
          ? `No hay resultados para "${trimmed}". Prueba con otras palabras.`
          : 'Prueba con otras palabras.'}
      </p>
      <button
        type="button"
        onClick={onContactSupport}
        className="rounded-md bg-brand px-4 py-2 text-caption-medium text-white transition-colors hover:bg-brand-hover"
      >
        Contactar soporte
      </button>
    </div>
  );
}
